import React, { Fragment } from 'react';

import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import PropTypes from 'prop-types';
import HeaderLabelIcons from 'screens/Team/TeamTasksListView/HeaderLabelIcons';
import styled, { css } from 'styled-components';
import { StyledBox, StyledTooltip, StyledTypography } from 'styles/common';

import theme from 'constants/theme';

const MeshTable = ({ headers, dataRows, tableFooter, headerRowStyles, stickyHeader = false, hiddenHeader = false }) => (
  <Table stickyHeader={stickyHeader}>
    <MeshTableHeader headersList={headers} headerRowStyles={headerRowStyles} hiddenHeader={hiddenHeader} />
    <TableBody>
      {dataRows.map((dataRow, index) => (
        <Fragment key={index}> {dataRow} </Fragment>
      ))}
    </TableBody>
    {tableFooter ? <>{tableFooter}</> : null}
  </Table>
);

MeshTable.propTypes = {
  headers: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      isSortable: PropTypes.bool,
      justify: PropTypes.string,
      orderBy: PropTypes.shape({
        columnId: PropTypes.string,
        orderType: PropTypes.string,
      }),
      handleSort: PropTypes.func,
    })
  ).isRequired,
  dataRows: PropTypes.arrayOf(PropTypes.element).isRequired,
  TableFooter: PropTypes.element,
};

const MeshTableHeader = ({ headersList, headerRowStyles, hiddenHeader }) => {
  const TableHeader = hiddenHeader ? HiddenTableHeader : TableHead;
  return (
    <TableHeader>
      <StyledTableRow {...headerRowStyles}>
        {headersList.map((headerObj) => {
          const {
            id,
            title,
            width,
            justify,
            isSortable,
            orderBy,
            handleSort,
            tooltip = '',
            fixedWidth = 0,
            minWidth = 0,
            leftGutter = 0,
          } = headerObj;

          return (
            <StyledTableCell
              size="small"
              variant="head"
              key={`header-${id}`}
              width={width}
              fixedWidth={fixedWidth}
              minWidth={minWidth}
              onClick={isSortable ? () => handleSort(id, orderBy) : null}
            >
              {hiddenHeader ? null : (
                <StyledBox display="flex" leftGutter={leftGutter} justifyContent={justify}>
                  <StyledTooltip title={tooltip}>
                    <StyledTypography variant="caption" color={theme.palette.text.label} clickable={isSortable}>
                      {title}
                    </StyledTypography>
                  </StyledTooltip>
                  {isSortable && (
                    <StyledHeaderLabelIcons
                      orderBy={orderBy.columnId}
                      headCell={{ id }}
                      order={String(orderBy.orderType).toLowerCase()}
                    />
                  )}
                </StyledBox>
              )}
            </StyledTableCell>
          );
        })}
      </StyledTableRow>
    </TableHeader>
  );
};

const StyledTableRow = styled(TableRow)`
  th,
  td {
    border-bottom: 1px solid ${(props) => props.borderColor ?? props.theme.palette.borders.lightGrey};
  }
`;

const StyledTableCell = styled(TableCell)`
  border-left: ${(props) => props.borderLeft && `1px solid ${props.theme.palette.borders.lightGrey}`};
  cursor: ${(props) => (props.isSortable ? 'pointer' : 'inherit')};
  ${(props) =>
    props.fixedWidth &&
    css`
      width: ${props.fixedWidth};
    `}
  ${(props) =>
    props.minWidth &&
    css`
      min-width: ${props.minWidth};
    `}
`;

const StyledHeaderLabelIcons = styled(HeaderLabelIcons)`
  margin-top: -4px;
  cursor: pointer;
`;

const HiddenTableHeader = styled(TableHead)`
  tr > th,
  tr > td {
    padding: 0;
    border-bottom: none !important;
  }
`;

export default MeshTable;
